import type {
  SelfServiceCampaignCreative,
  SelfServiceCampaignVariant,
} from '../types/self-service-campaign.types';

export function getPrimaryVariants(creative: SelfServiceCampaignCreative): SelfServiceCampaignVariant[] {
  return creative.variants.filter((variant) => variant.is_primary);
}

export function isVideoMimeType(mimeType: string | null | undefined): boolean {
  return Boolean(mimeType?.startsWith('video/'));
}
